import type { HydrateAction } from './hydrate.action';
import type { TurnOffFlipperFeatureResponseAction } from './turnOffFlipperFeature.action';
import type { TurnOnFlipperFeatureResponseAction } from './turnOnFlipperFeature.action';

export * from './turnOnFlipperFeature.action';
export * from './turnOffFlipperFeature.action';
export * from './hydrate.action';

export type FlipperAction = TurnOnFlipperFeatureResponseAction | TurnOffFlipperFeatureResponseAction | HydrateAction;
